/**
 * Lettura degli eventi server-sent che arrivano dal backend.
 *
 * Le rotte lunghe verso DeepSeek rispondono a pezzi per non incappare nel taglio
 * a 100 secondi di Cloudflare. HttpClient consegna la risposta solo quando e'
 * finita, quindi qui si legge il corpo con fetch e i frame vanno ricomposti a
 * mano: un chunk di rete non rispetta i confini fra un evento e il successivo.
 */

export interface EventoSse {
  nome: string;
  dati: any;
}

export class LettoreSse {
  private resto = '';

  /** Frammento di corpo in ingresso, eventi completi in uscita. */
  aggiungi(frammento: string): EventoSse[] {
    this.resto += frammento;
    const frames = this.resto.split(/\r?\n\r?\n/);
    // L'ultimo pezzo non e' ancora chiuso da una riga vuota: resta in attesa.
    this.resto = frames.pop() ?? '';
    return frames.map((frame) => this.leggiFrame(frame)).filter((e): e is EventoSse => e !== null);
  }

  private leggiFrame(frame: string): EventoSse | null {
    let nome = 'message';
    const dati: string[] = [];
    for (const riga of frame.split(/\r?\n/)) {
      if (riga.startsWith('event:')) {
        nome = riga.slice(6).trim();
      } else if (riga.startsWith('data:')) {
        dati.push(riga.slice(5).trim());
      }
      // Le altre righe (i commenti che iniziano per ':', gli id) non ci servono.
    }
    if (dati.length === 0) {
      return null;
    }
    try {
      return { nome, dati: JSON.parse(dati.join('\n')) };
    } catch {
      // Un frame illeggibile non deve far cadere quelli che seguono.
      return null;
    }
  }
}
